export const STATUS_COLORS = {
  active: 'bg-green-100 text-green-700',
  paused: 'bg-yellow-100 text-yellow-700',
  suspended: 'bg-gray-100 text-gray-700',
  warning: 'bg-yellow-100 text-yellow-700',
  critical: 'bg-red-100 text-red-700',
  info: 'bg-blue-100 text-blue-700',
  verified: 'bg-green-100 text-green-700',
  pending: 'bg-yellow-100 text-yellow-700',
  failed: 'bg-red-100 text-red-700',
  delivered: 'bg-green-100 text-green-700',
  bounced: 'bg-red-100 text-red-700',
  queued: 'bg-gray-100 text-gray-700',
  sent: 'bg-blue-100 text-blue-700',
  complained: 'bg-orange-100 text-orange-700',
  super_admin: 'bg-purple-100 text-purple-700',
  admin: 'bg-indigo-100 text-indigo-700',
  viewer: 'bg-gray-100 text-gray-700',
  custom: 'bg-purple-100 text-purple-700',
  free: 'bg-gray-100 text-gray-700',
  starter: 'bg-blue-100 text-blue-700',
  pro: 'bg-indigo-100 text-indigo-700',
  growth: 'bg-emerald-100 text-emerald-700',
  scale: 'bg-amber-100 text-amber-700',
  allow: 'bg-green-100 text-green-700',
  block: 'bg-red-100 text-red-700',
  warn: 'bg-yellow-100 text-yellow-700',
  resolved: 'bg-green-100 text-green-700',
  invalidmailbox: 'bg-red-100 text-red-700',
  mailboxfull: 'bg-yellow-100 text-yellow-700',
  policyrejection: 'bg-red-100 text-red-700',
  ratelimited: 'bg-orange-100 text-orange-700',
  infrastructureblock: 'bg-red-100 text-red-700',
  contentrejection: 'bg-red-100 text-red-700',
  other: 'bg-gray-100 text-gray-700',
  account: 'bg-blue-100 text-blue-700',
  domain: 'bg-indigo-100 text-indigo-700',
  alert: 'bg-yellow-100 text-yellow-700',
  engine: 'bg-purple-100 text-purple-700',
  billing: 'bg-emerald-100 text-emerald-700',
  admin_user: 'bg-indigo-100 text-indigo-700',
  inbox: 'bg-green-100 text-green-700',
  spam: 'bg-red-100 text-red-700',
  unknown: 'bg-gray-100 text-gray-700',
  missing: 'bg-gray-100 text-gray-700',
  clean: 'bg-green-100 text-green-700',
  listed: 'bg-red-100 text-red-700',
  pause: 'bg-red-100 text-red-700',
  throttle: 'bg-yellow-100 text-yellow-700',
  resume: 'bg-green-100 text-green-700',
  approved: 'bg-green-100 text-green-700',
  denied: 'bg-red-100 text-red-700',
  student: 'bg-blue-100 text-blue-700',
  startup: 'bg-purple-100 text-purple-700',
  warming: 'bg-orange-100 text-orange-700',
  completed: 'bg-green-100 text-green-700',
} as const
